import React from 'react';
import DENTModalOverviewPeriodontalItem from './DENTModalOverviewPeriodontalItem';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalItemModal.module.scss';
import { PeriodontalObject } from '../../Interfaces/PeriodontalObject.interface';
import { useDENTContext } from '../../Services/DENTContext';
import { OverviewMode } from '../../Enums/OverviewMode.enum';
import { joinClasses } from '../../../../Utils/className.util';

interface Props {
	periodontalItem: PeriodontalObject;
	onClick: (periodontalItem: PeriodontalObject) => void;
	isSelected: boolean;
}

const DENTModalOverviewPeriodontalItemModal = ({
	periodontalItem,
	onClick,
	isSelected,
}: Props) => {
	const { overviewMode } = useDENTContext();

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				overviewMode === OverviewMode.PERIODONTAL
					? styles.quickAdjustmentWrapper
					: '',
			])}>
			<DENTModalOverviewPeriodontalItem
				title={periodontalItem.title}
				periodontalItem={periodontalItem.item}
				isSelected={isSelected}
				onClick={onClick}
			/>
		</div>
	);
};

export default DENTModalOverviewPeriodontalItemModal;
